const AccountFindRouter = [
  {
    path     : '/account/find',
    component: () => import ('@/app/layout/view/layout-default.vue'),
    redirect : '/account/find/select',
    children : [
      {
        path     : 'select',
        component: () => import('@/app/account/find/view/account-find-select.vue'),
      },
      {
        path     : 'confirm-id',
        component: () => import('@/app/account/find/view/account-find-confirm-id.vue'),
      },
      {
        path     : 'confirm-pw',
        component: () => import('@/app/account/find/view/account-find-confirm-pw.vue'),
      },
      {
        path     : 'confirm-auth/:find/:type',
        component: () => import('@/app/account/find/view/account-find-confirm-auth.vue'),
      },
      {
        path     : 'result-id',
        component: () => import('@/app/account/find/view/account-find-result-id.vue'),
      },
      {
        path     : 'change-pw',
        component: () => import('@/app/account/find/view/account-find-change-pw.vue'),
      },
      {
        path     : 'result-pw',
        component: () => import('@/app/account/find/view/account-find-result-pw.vue'),
      },
      {
        path     : 'result-pw-error',
        component: () => import('@/app/account/find/view/account-find-result-pw-error.vue'),
      }
    ]
  }
];

export default AccountFindRouter;
